export default __webpack_public_path__ + "static/lit-e4b8ff474071c84c5e02c554eba0bf95.svg";